import { withProtectedResource } from '@delmonicos/shared-design-system-react/src/components/protected-resources/with-protected-resource.helper';
import { GatewayRoleModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/output/gateway-role.model';
import {
  hasAccessTo,
  safeHasAccessTo,
} from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/helper/has-access-to';
import { ActionsByResource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/action.enum';
import { Resource } from '@delmonicos/shared-sdk/libs/cpms/src/libs/identity-service-lib/src/wrapper/enums/resource.enum';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { permissions } from '@app/core/authentication/authentication.slice';
import { useAppSelector } from '@app/core/hooks';
import { useCpmsBoGetRoleQuery } from '@app/core/service/cpms-bo-role.service';
import { useSetPageActionContext } from '@app/shared/layout/page-layout/page-layout-action.context-provider';
import { useSetPageTitleContext } from '@app/shared/layout/page-layout/page-layout-title.context-provider';

import { RoleDetailsView } from './role-details.view';

interface RoleDetailsControllerProps {
  resource: GatewayRoleModel;
}

const RoleDetailsController = (
  props: RoleDetailsControllerProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { resource } = props;

  // USER PERMISSIONS //////////////////////////////////////////////////////////

  const userPermissions = useAppSelector(permissions);

  // ACTIONS ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // PAGE TITLE ////////////////////////////////////////////////////////////////

  const setPageTitle = useSetPageTitleContext();

  useEffect(() => {
    setPageTitle(resource.name);
  }, [resource, setPageTitle]);

  // PAGE ACTIONS //////////////////////////////////////////////////////////////

  const setPageAction = useSetPageActionContext();

  useEffect(() => {
    const actions: React.JSX.Element[] = [];

    if (
      userPermissions &&
      hasAccessTo(userPermissions, {
        resourceName: Resource.ROLES,
        action: ActionsByResource.ROLES.UPDATE,
      })
    ) {
      // TODO: Waiting for role edition
      // actions.push(
      //   <ButtonIcon
      //     onClick={() => setActionUpdateIsDialogOpen(true)}
      //     icon="edit-05"
      //     key="update"
      //   />,
      // );
    }

    setPageAction(actions);
  }, [setPageAction, userPermissions]);

  // PAGE BREADCRUMB ///////////////////////////////////////////////////////////

  // Nothing to do

  // HANDLERS //////////////////////////////////////////////////////////////////

  // Nothing to do

  // RENDER ////////////////////////////////////////////////////////////////////

  return <RoleDetailsView role={resource} />;
};

export const RoleDetailsPage = (): React.JSX.Element => {
  const userPermissions = useAppSelector(permissions);
  const params = useParams();
  const queryState = useCpmsBoGetRoleQuery(params.id ?? '');

  const { Component } = withProtectedResource<
    GatewayRoleModel,
    {},
    GatewayRoleModel
  >(RoleDetailsController, queryState, {
    isAuthorized: () =>
      safeHasAccessTo(userPermissions, {
        resourceName: Resource.ROLES,
        action: ActionsByResource.ROLES.READ,
      }),
  })({});

  return Component;
};
